export class FieldStatus {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "RevalidationStatus",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "suggestedAction",
            "baseName": "suggestedAction",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FieldStatus.attributeTypeMap;
    }
    constructor() {
    }
}
